import { makeModuleStateSelector } from "@client/content/selectors";
import { getMultiselectValue } from "@client/lib/settings";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type CourseDetail } from "./types";

export const localStateSelector = makeModuleStateSelector<CourseDetail.AppState>(defaultState, previewState);

const makeLocalStateActiveCourseSectionsSelector = () =>
  createSelector(
    [localStateSelector],
    (localState): CourseDetail.CourseModule[] | null => localState.activeCourse?.modules ?? []
  );
export const makeSectionsSelector = () => {
  const sectionsValueSelector = getSettingValueSelector(
    TargetSelector.Entity,
    "sections",
    undefined,
    getMultiselectValue
  );
  const sectionsSelector = makeLocalStateActiveCourseSectionsSelector();

  return createSelector([sectionsValueSelector, sectionsSelector], (sectionsValue, sections) => {
    if (!sectionsValue || !sectionsValue.length || !sections?.length) return sections ?? [];

    return sections.filter((x) => sectionsValue.includes(x.id));
  });
};

const makeLocalStateActiveCourseSelector = () =>
  createSelector(
    [localStateSelector],
    (localState): CourseDetail.CourseAppState | null => localState.activeCourse ?? null
  );

export const makeActiveLessonSelector = () => {
  const activeCourseSelector = makeLocalStateActiveCourseSelector();

  return createSelector(
    [activeCourseSelector],
    (activeCourse): CourseDetail.CourseModuleLesson | null =>
      activeCourse?.lessons.find((x) => x.id === activeCourse?.activeLessonId) ?? null
  );
};

export const makeActiveSectionSelector = () => {
  const activeCourseSelector = makeLocalStateActiveCourseSelector();
  const sectionsSelector = makeSectionsSelector();

  return createSelector(
    [activeCourseSelector, sectionsSelector],
    (activeCourse, sections): CourseDetail.CourseModule | null =>
      sections.find((x) => x.id === activeCourse?.activeModuleId) ?? null
  );
};
